module.exports = __webpack_public_path__ + "static/img/success.1c9636ea.jpg";